import * as Constants from '../constants';
import { default as Endpoint } from '../../api/Endpoint';

export function requestActivationStatus() {
  return {
    type: Constants.REQUEST_ACTIVATION_STATUS
  };
}

export function receiveActivationStatus(json, error) {
  return {
    type: Constants.RECEIVE_ACTIVATION_STATUS,
    data: json,
    error
  };
}

export function requestActivate() {
  return {
    type: Constants.REQUEST_ACTIVATE
  };
}

export function receiveActivate(json, error) {
  return {
    type: Constants.RECEIVE_ACTIVATE,
    data: json,
    error
  };
}

export function requestReadonly() {
  return {
    type: Constants.REQUEST_READONLY
  };
}

export function receiveReadonly(json, error) {
  return {
    type: Constants.RECEIVE_READONLY,
    data: json,
    error
  };
}

export function getActivationStatus(options = {}) {
  const path = 'ecs/api/activation';
  return new Endpoint(path, requestActivationStatus, receiveActivationStatus)
    .withMethod('GET')
    .withOptions(options)
    .call();
}

export function activateEcs(options = {}) {
  const path = 'ecs/api/activation';
  return new Endpoint(path, requestActivate, receiveActivate)
    .withMethod('POST')
    .withOptions(options)
    .call();
}

export function toggleReadonly(options = {}) {
  const path = 'ecs/api/readonly';
  return new Endpoint(path, requestReadonly, receiveReadonly)
    .withMethod('POST')
    .withOptions(options)
    .call();
}
